module.exports = __webpack_public_path__ + "static/im-american-express-43dab46b91aaeff7d7a298461096d9d0.png";